/**
 * Safely parse and validate price values
 * @param value - Any price value (string, number, null, undefined)
 * @returns Valid number >= 0, or 0 if invalid
 */
export const parseAndValidatePrice = (value: any): number => {
  if (value === null || value === undefined) return 0;
  const parsed = parseFloat(String(value));
  if (isNaN(parsed) || parsed < 0) {
    console.warn(`⚠️ Invalid price detected:`, value);
    return 0;
  }
  return parsed;
};

/**
 * Validate if a MenuItem has a valid base price or variant/size prices
 */
export const hasValidPrice = (item: any): boolean => {
  // Check base price - prioritize 'price' field, fallback to 'basePrice'
  const priceValue = item.price ?? item.basePrice;
  if (priceValue && !isNaN(parseFloat(priceValue)) && parseFloat(priceValue) >= 0) {
    return true;
  }
  
  // Check variant prices
  if (item.Variants?.length > 0) {
    return item.Variants.some((v: any) => v.price && !isNaN(parseFloat(v.price)));
  }
  
  // Check size prices
  if (item.Sizes?.length > 0) {
    return item.Sizes.some((s: any) => s.price && !isNaN(parseFloat(s.price)));
  }
  
  return false;
};
